/**
 * Build a stake.com URL with the Gumble affiliate code.
 * All external links to Stake should go through this helper.
 */
export function stakeUrl(pathOrGameSlug = "/") {
  let path = pathOrGameSlug;
  if (path && !path.startsWith("/") && !path.startsWith("http")) {
    // Bare game slug -> casino games path
    path = `/casino/games/gumble-${path}`;
  }
  const base = "https://stake.com";
  const url = path.startsWith("http") ? path : `${base}${path}`;
  const sep = url.includes("?") ? "&" : "?";
  // Do not double-append if already present
  if (/[?&]c=/.test(url)) return url;
  return `${url}${sep}c=gumble`;
}

export const STAKE_HOME = stakeUrl("/");
